// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'recharts';

const CustomPieChartLabel = (props) => {
  const { percentage, label, width, fontSize } = props;
  if (percentage < 2) return null;

  return (
    <Text {...props} width={width} fontSize={fontSize}>
      {label.length > 60 ? `${label.substring(0, 58)}...` : label}
    </Text>
  );
};

CustomPieChartLabel.propTypes = {
  percentage: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  fontSize: PropTypes.number.isRequired,
};

export default CustomPieChartLabel;
